import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import {
  getAlertStatus,
  getIsRecentlyAdded,
  getIsReservableVehicle
} from '~/selectors';
import {
  BlueWrapper,
  RedWrapper,
  YellowWrapper,
  BadgeText,
  PurpleWrapper
} from './Badge.styles';
import OnHoldTooltip from './OnHoldTooltip';

type OwnProps = Omit<React.HTMLProps<HTMLDivElement>, 'ref'>;

const Locked = (props: OwnProps) => (
  <RedWrapper {...props}>
    <BadgeText>Purchase in Progress</BadgeText>
  </RedWrapper>
);

const PreOrder = (props: OwnProps) => (
  <BlueWrapper {...props}>
    <BadgeText>Pre-Order Now</BadgeText>
  </BlueWrapper>
);

const OnHold = (props: OwnProps) => (
  <YellowWrapper {...props}>
    <OnHoldTooltip />
  </YellowWrapper>
);

const Recent = (props: OwnProps) => (
  <PurpleWrapper {...props}>
    <BadgeText>Recently Added</BadgeText>
  </PurpleWrapper>
);

export default function Badge(props: OwnProps) {
  const { isInitialized, shouldShowTimer } = useContext(UnlockTimerContext);
  const { purchasePending } = useSelector(getAlertStatus);
  const isReservable = useSelector(getIsReservableVehicle);
  const isRecentlyAdded = useSelector(getIsRecentlyAdded);

  switch (true) {
    case !isInitialized:
      return null;
    case purchasePending && shouldShowTimer:
      return <OnHold {...props} />;
    case purchasePending:
      return <Locked {...props} />;
    case isReservable:
      return <PreOrder {...props} />;
    case isRecentlyAdded:
      return <Recent {...props} />;
    default:
      return null;
  }
}
